import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class DataService {
  private dataSource = new BehaviorSubject("default message");

  currentResearchData = this.dataSource.asObservable();

  constructor() {
    this.researchDocumentDataService(null);
  }

  researchDocumentDataService(message: any) {
    this.dataSource.next(message);
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/data.service.ts